import { render, staticRenderFns } from "./SlideshowSlider.vue?vue&type=template&id=25cce7d5&scoped=true&"
import script from "./SlideshowSlider.vue?vue&type=script&lang=js&"
export * from "./SlideshowSlider.vue?vue&type=script&lang=js&"
import style0 from "./SlideshowSlider.vue?vue&type=style&index=0&id=25cce7d5&lang=scss&scoped=true&"
import style1 from "./SlideshowSlider.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cce7d5",
  null
  
)

export default component.exports